export const mvIulaanTypes = [
  {
    value: "",
    label: "ހުރިހާ",
  },
   {
    value: "vazeefaa",
    label: "ވަޒީފާގެ ފުރުޞަތު",
  },
  {
    value: "beelan",
    label: "ބީލަން",
  },
   {
    value: "kuyyah-hifun",
    label: "ކުއްޔަށް ހިފުން",
  },
  {
    value: "masakkaiy",
    label: "މަސައްކަތް",
  },
  {
    value: "gannan-beynunvaa",
    label: "ގަންނަން ބޭނުންވާ ތަކެތި",
  },
  {
    value: "kuyyah-dhinun",
    label: "ކުއްޔަށް ދިނުން",
  },
 
 
  {
    value: "thamreenu",
    label: "ތަމްރީނު",
  },
  {
    value: "neelan",
    label: "ނީލަން",
  },
  {
    value: "aanmu-mauloomaathu",
    label: "ޢާންމު މަޢުލޫމާތު",
  },
  {
    value: "dhennevun",
    label: "ދެންނެވުން",
  },
  {
    value: "mubaaraaiy",
    label: "މުބާރާތް",
  },
  {
    value: "noos-bayaan",
    label: "ނޫސްބަޔާން",
  },
  {
    value: "insurance",
    label: "އިންޝުއަރެންސް",
  },
  
];